export interface Review {
  id: string
  quote: string
  author: string
  location: string
  job: string
  rating: number
  source: string
}

/**
 * Replace these with the verbatim text of your real Google / Yelp reviews.
 * Keep the same shape — the carousel renders whatever is in this array.
 */
export const reviews: Review[] = [
  {
    id: 'maria-g',
    quote:
      "We had old furniture, appliances, and yard debris sitting in our garage for months. I didn't know where to start. Javier came out, gave us a fair price, and we were done the next day. No hassles, no problems, just a clean garage. I'm already recommending him to all my neighbors.",
    author: 'Maria G.',
    location: 'Carlsbad, CA',
    job: 'Garage cleanout',
    rating: 5,
    source: 'Google Review',
  },
  {
    id: 'dave-r',
    quote:
      'Called on a Tuesday morning about a busted sectional and a dead fridge. Javier quoted me on the phone, showed up that same afternoon, and the price was exactly what he said. No upsell, no games.',
    author: 'Dave R.',
    location: 'Oceanside, CA',
    job: 'Furniture & appliance removal',
    rating: 5,
    source: 'Google Review',
  },
  {
    id: 'kelly-s',
    quote:
      'Our remodel left a mountain of drywall, tile, and old carpet in the driveway. They loaded everything, swept the concrete, and you would never know it was there. Super respectful of the property.',
    author: 'Kelly S.',
    location: 'Encinitas, CA',
    job: 'Construction debris cleanup',
    rating: 5,
    source: 'Google Review',
  },
  {
    id: 'tom-b',
    quote:
      'I manage a few rentals in Vista and San Marcos. Javier is who I call for every turnover now. He answers the phone, he shows up when he says, and the invoices match the quote every time.',
    author: 'Tom B.',
    location: 'Vista, CA',
    job: 'Rental turnover cleanouts',
    rating: 5,
    source: 'Google Review',
  },
  {
    id: 'anita-l',
    quote:
      'Years of palm fronds and branches behind the fence. Two guys, one trailer, done in a couple hours. Fair price and really friendly. Nice to support someone local.',
    author: 'Anita L.',
    location: 'Escondido, CA',
    job: 'Yard waste removal',
    rating: 5,
    source: 'Google Review',
  },
]
